export default "__VITE_ASSET__4b63d181__"